import React, { useState, useEffect } from 'react'
import { translate } from "../Services/translation";

const MuurikkaVideoPopup = () => {
    const [btnState, setBtnState] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth); 
    const videoBlock = document.querySelector(".video")
    const sliderBlock = document.querySelector(".slider__container")

    const handleWindowSizeChange = () => {
        setScreenWidth(window.innerWidth);
    }

    /**
     *
     * @type {HTMLVideoElement}
     */
    const muurikkaVideoEl = document.querySelector(".muurikkaVideo");
    const muurikkaVideo = muurikkaVideoEl !== null;
    const isMobile = screenWidth <= 768;

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);

        if (muurikkaVideoEl && muurikkaVideoEl.autoplay && muurikkaVideo) {
            handleVideoBtnClick();
        }
        
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const handleVideoBtnClick = (e = null, forcePlay = false) => {
        setBtnState((prev) => !prev);
        videoBlock.classList.toggle('showRecipeVideo')
        sliderBlock.classList.toggle('hideSliderBlock')

        const originalMutedState = muurikkaVideoEl.muted;
        if (forcePlay || muurikkaVideoEl.autoplay && muurikkaVideoEl.paused) {
            if (!muurikkaVideoEl.muted) {
                muurikkaVideoEl.muted = true;
            }

            muurikkaVideoEl.play();
            muurikkaVideoEl.muted = originalMutedState;
        }
    };

  return (
    <>
        {!muurikkaVideo ?
            null :
            <div className="muurikka-btn muurikka-btn--video" onClick={(e) => handleVideoBtnClick(e, true)}>
                <svg className="playbutton">
                    {!isMobile &&
                        <use href="/UI/images/sprites/habo-sprite.svg#playbutton"></use>
                    }
                    {isMobile &&
                        <use href="/UI/images/sprites/habo-sprite.svg#playbuttonSmall"></use>
                    }
                </svg>
                <span className="muurikka-btn--video__text">
                    {translate("recipe.videobuttontext")}
                </span>
            </div>

        }
     
    </>
  )
}

export default MuurikkaVideoPopup
